<template>
  <div>
    <div class="mx-auto" style="display: flex; justify-content: center;" :id="konvaId" :style="convaContStyle">
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="teal"
      ></v-progress-linear>
    </div>
    <div v-if="!hideButtons" style="margin-top: 20px;" >
      <v-btn 
        v-for="pointcolor in colors"
        :key="'colorchoose' + pointcolor"
        :color="color == pointcolor ? 'grey lighten-1' : ''"
        small
        class="mr-1"
        @click="color = pointcolor"
      >
          <div class="ball" :style="`background-color: ${pointcolor}`"></div>
      </v-btn>
      <v-btn
        @click="color = 'erase'"
        :color="color == 'erase' ? 'grey lighten-1' : ''"
        style="height: 28px; width: 50px;"
      >
        <v-icon small class="pa-0">mdi-eraser</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import Konva from 'konva';

export default {
  props: ['offsetY', 'offsetX', 'colorOverride', 'buttonIndex', 'loading', 'maxHeight', 'maxWidth', 'base', 'value', 'show', 'hideButtons', 'url', 'disableClicks'],
  data: () => ({
    color: 'red',
    colors: [
      'red',
      'lightgreen',
      'yellow',
      'grey'
    ],
    baseImage: {
      height: null,
      width: null,
      x: null,
      y: null
    },
    layer: null,
    imageObject: null,
    idCounter: 0,
    konvaId: Math.random().toString()  
  }),
  created() {
    if(this.buttonIndex) this.color = this.colors[this.buttonIndex]

    this.$nextTick(() => {
      const con = this.maxHeight || document.querySelector('#card-container').clientHeight - 110
      const colcon = this.maxWidth || document.querySelector('#col-container').clientWidth
      const width = Math.min(con, colcon)
      const height = Math.min(con, colcon)

      const stage = new Konva.Stage({
        container: this.konvaId,
        width,
        height
      });
  
      var layer = new Konva.Layer();
      stage.add(layer);

      layer.on('click', (e) => {
        this.layerClicked(e, width, layer)
      })

      var imageObj = new Image();

      var self = this
      var image;
      var data;
      imageObj.onload = function() {
        const w = imageObj.width
        const h = imageObj.height
        
        data = self.getImageMeasures(w, h, width, height)

        image = new Konva.Image({
          ...data,
          image: imageObj
        });

        layer.add(image);
        self.drawPoints(layer)

        self.imageObject = image
      };

      imageObj.src = this.url || this.base?.url

      layer.on('mouseover', function () {
        document.body.style.cursor = 'crosshair';
      });

      layer.on('mouseout', function () {
        document.body.style.cursor = 'default';
      });

      this.layer = layer
      this.stage = stage
    })
  },
  computed: {
    convaContStyle() {
      if(this.maxHeight || this.maxWidth) {
        return `max-width: ${this.maxWidth}px; max-height: ${this.maxHeight}`
      }
      return ''
    }
  },
  methods: {
    downloadURI(uri, name) {
      var link = document.createElement('a');
      link.download = name;
      link.href = uri;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    downloadMap() {
      const dataUrl = this.stage.toDataURL({ pixelRatio: 3 });
      this.downloadURI(dataUrl, 'map.png')
    },
    getId() {
      return Math.random().toString()
    },
    getNewId() {
      let max = 0
      this.value.forEach(p => {
        if(Number(p.id) > max) max = Number(p.id)
      })

      return max + 1
    },
    layerClicked(e) {
      if(this.disableClicks) return

      if(this.color == 'erase') return

      let newpoint = {
        x: ( e.evt.layerX - this.baseImage.x - (this.offsetX || 0) ) / this.baseImage.width,
        y: ( e.evt.layerY - this.baseImage.y - (this.offsetY || 0) ) / this.baseImage.height,
        color: this.colorOverride || this.color,
        style: 'ball',
        id: this.getNewId().toString()
      }

      let ne = this.value.concat(newpoint)
      console.log(e.evt.layerX, this.baseImage.x, this.baseImage.width, this.offsetX || 0)
      console.log('First part: ', ( e.evt.layerX - this.baseImage.x - this.offsetX || 0))
      console.log( ( e.evt.layerX - this.baseImage.x - this.offsetX || 0 ) / this.baseImage.width)
      //baseImage x, y, width and height right right
      // 

      // ne = this.value.concat({
      //   x: this.baseImage.x + this.baseImage.width,
      //   y: this.baseImage.y + this.baseImage.height,
      //   color: this.colorOverride || this.color,
      //   style: 'ball',
      //   id: this.getNewId().toString()
      // })

      this.idCounter++

      this.$emit('input', ne)

      // var circle = new Konva.Circle({
      //   x: e.evt.layerX,
      //   y: e.evt.layerY,
      //   radius: width / 140,
      //   fill: this.color,
      //   stroke: 'black',
      //   strokeWidth: 1,
      // });

      // circle.on('click', (e) => {
      //   if(this.color != 'erase') return
      //   console.log(e)
      //   e.target.remove()
      // })

      // add the shape to the layer
      // layer.add(circle);
    },
    getImageMeasures(imageWidth, imageHeight, canvasWidth, canvasHeight) {
      const imageRatio = imageWidth / imageHeight
      let x
      let y
      let width
      let height
      if(imageRatio > 1) {
        // wider than higher
        x = 0
        height = canvasHeight / imageRatio
        y = (canvasHeight - height) / 2
        width = canvasWidth
      } else {
        // higher than wider
        y = 0
        width = canvasWidth * imageRatio
        x = (canvasWidth - width) / 2
        height = canvasHeight
      }
      let data = {
        x, y, height, width
      }

      this.baseImage = data

      return data
    },
    drawPoints() {
      this.value?.forEach(point => {
        var self = this
        var circle = new Konva.Circle({
          y: self.baseImage.height * point.y  + self.baseImage.y,
          x: self.baseImage.width * point.x + self.baseImage.x,
          radius: Math.max((self.baseImage.width + this.baseImage.x) / 120, 4),
          fill: point.color,
          stroke: 'black',
          strokeWidth: 0,
          id: point.id,
          clip_id: point.clip_id
        });

        circle.on('click', (e) => {
          if(self.color != 'erase') {
            this.$emit('open_clip_by_id', e.target.attrs.clip_id)
            return
          }
          this.removeById(e.target.attrs.id)
        })

        circle.on('mouseover', function (evt) {
          var shape = evt.target;
          document.body.style.cursor = 'pointer';
          shape.scaleX(1.2);
          shape.scaleY(1.2);
          shape.moveToTop();
        });

        circle.on('mouseout', function (evt) {
          var shape = evt.target;
          document.body.style.cursor = 'default';
          shape.scaleX(1);
          shape.scaleY(1);
        });

        this.layer.add(circle);
      })
    },
    // drawAreas() {
    //   // let w = this.baseImage.width
    //   // let h = this.baseImage.height
    //   var triangle = new Konva.Shape({
    //     sceneFunc: function (context, shape) {
    //       context.beginPath();
    //       context.moveTo(0.0468384074941452, 0.0891875766700123);
    //       context.lineTo(24, 143.63);
    //       context.lineTo(64, 45.63);
    //       // context.quadraticCurveTo(150, 100, 260, 170);
    //       context.closePath();

    //       // (!) Konva specific method, it is very important
    //       context.fillStrokeShape(shape);
    //     },
    //     fill: '#00D2FF',
    //     stroke: 'black',
    //     strokeWidth: 1,
    //   });

    //   this.layer.add(triangle);
    // },
    removeById(id) {
      let point = this.layer.find(`#${id}`)[0]
      if(!point) return
      point.destroy()
      this.$emit('input', this.value.filter(p => p.id != id))
    }
  },
  watch: {
    value: {
      handler() {
        // this.layer.find('circle').destroy()
        var circles = this.layer.find('Circle')
        circles.forEach(circle => circle.destroy())
        // TODO clear all shapes
        this.drawPoints()
        // this.drawAreas()
      },
      deep: true
    },
    buttonIndex: {
      handler(newVal) {
        this.color = this.colors[newVal]
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
  .red {
    background-color: rgb(246, 60, 60);
  }

  .green {
    background-color: rgb(11, 168, 11);
  }

  .ball {
    height: 15px;
    width: 15px;
    border-radius: 50%;
  }

  .konvajs-content > canvas {
    margin: 0 auto;
  }
</style>